import { DECLINED_STEPS_KEY as DECLINED_KEY } from './runtime-storage';

export function getDeclinedSteps(): Set<string> {
  try {
    const raw = sessionStorage.getItem(DECLINED_KEY);
    if (raw) return new Set(JSON.parse(raw) as string[]);
  } catch {
    /* ignore */
  }
  return new Set();
}

export function addDeclinedStep(stepId: string): void {
  try {
    const declined = getDeclinedSteps();
    declined.add(stepId);
    sessionStorage.setItem(DECLINED_KEY, JSON.stringify([...declined]));
  } catch {
    /* ignore */
  }
}
